export default __webpack_public_path__ + "static/media/04.781c609a.jpg";